import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import {
  BulkPaymentHistoryItem,
  BulkPaymentHistoryPagination,
  BulkPaymentHistoryRequest,
  BulkPaymentHistoryState,
} from 'redux/types/Allocation.types';

export const bulkPaymentHistoryInitialState: BulkPaymentHistoryState = {
  loading: false,
  error: null,
  data: [],
  pagination: null,
};

const bulkPaymentHistorySlice = createSlice({
  name: 'bulkPaymentHistory',
  initialState: bulkPaymentHistoryInitialState,
  reducers: {
    fetchBulkPaymentHistoryReq(
      state,
      action: PayloadAction<BulkPaymentHistoryRequest>
    ) {
      state.loading = true;
      state.error = null;
    },
    fetchBulkPaymentHistorySuccess(
      state,
      action: PayloadAction<{
        data: BulkPaymentHistoryItem[];
        pagination: BulkPaymentHistoryPagination;
      }>
    ) {
      state.loading = false;
      state.data = action.payload.data;
      state.pagination = action.payload.pagination;
    },
    fetchBulkPaymentHistoryFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    resetBulkPaymentHistoryState: () => bulkPaymentHistoryInitialState,
  },
});

export const {
  fetchBulkPaymentHistoryReq,
  fetchBulkPaymentHistorySuccess,
  fetchBulkPaymentHistoryFailure,
  resetBulkPaymentHistoryState,
} = bulkPaymentHistorySlice.actions;

export default bulkPaymentHistorySlice.reducer;
